var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpportunityAction(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.49759 9.3491C2.88301 9.04178 2.3511 8.57759 1.95021 7.99872C1.54932 7.41984 1.29217 6.74464 1.20212 6.03448C1.11207 5.32433 1.19198 4.60173 1.43459 3.93237C1.6772 3.26301 2.07482 2.66811 2.5913 2.20174C3.10778 1.73537 3.72675 1.41232 4.39195 1.26195C5.05715 1.11159 5.74749 1.13867 6.40023 1.34073C7.05296 1.5428 7.64739 1.91345 8.12949 2.41899C8.61159 2.92453 8.96608 3.54894 9.16072 4.23545H10.2047C10.8763 4.23422 11.5228 4.50414 12.0111 4.98966C12.4994 5.47518 12.7924 6.13936 12.8297 6.84548C12.8671 7.55161 12.646 8.24595 12.2119 8.7856C11.7779 9.32525 11.1639 9.66913 10.4963 9.74648M7.57998 6.69201L5.8303 9.7629H8.16321L6.41353 12.8338",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunityAction);
export default __webpack_public_path__ + "static/media/OpportunityAction.1d5a4c4ee75ffbd6b3a5442ff9175436.svg";
export { ForwardRef as ReactComponent };